import { ServiceItem, Doctor, Testimonial, PricingPlan, BlogPost, ClinicLocation } from "@/types";

export const CLINIC_INFO = {
  name: "J.D. Dentals",
  tagline: "Advanced Care, Brighter Smiles",
  heroHeading: "Your Smile, Our Passion",
  heroSubtitle:
    "Experience world-class dental care with modern technology and a gentle touch in Greater Noida. Led by our specialist founders, we bring painless laser dentistry, 3D smile design, and European sterilization protocols under one roof.",
  phone: "098000 00881",
  email: "vnsn1524@gmail.com",
  website: "jddentals.com",
  emergencyHotline: "098000 00881",
};

export const CLINIC_LOCATIONS: ClinicLocation[] = [
  {
    id: "sky-plaza",
    slug: "sky-plaza",
    name: "J.D. Dentals – Sky Plaza",
    shortName: "Sky Plaza",
    address: "SKY PLAZA, Shri Radha Sky Garden, F-25, Greater Noida West, UP 201306",
    fullAddress: "SKY PLAZA, Shri Radha Sky Garden, F-25, Greater Noida West, Uttar Pradesh 201306",
    phone: "098000 00881",
    email: "vnsn1524@gmail.com",
    rating: 5.0,
    reviewCount: 82,
    hours: {
      weekday: "9:30 AM – 12:30 PM, 5:30 PM – 8:00 PM",
      saturday: "9:30 AM – 12:30 PM, 5:30 PM – 8:00 PM",
      sunday: "Closed",
    },
    mapUrl: "https://www.google.com/maps/place/J.D.+Dentals/@28.5802,77.3341,17z",
    embedMapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3505.5!2d77.3341!3d28.5802!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDM0JzQ4LjAiTiA3N8KwMjAnMDIuOCJF!5e0!3m2!1sen!2sin!4v1234567890",
    landmark: "Located in Sky Plaza, near Shri Radha Sky Garden",
    features: [
      "Advanced Dental Implants",
      "Teeth Whitening",
      "Root Canal Treatment",
      "Orthodontics & Braces",
      "Pediatric Dentistry",
      "Emergency Dental Care",
    ],
  },
  {
    id: "gaur-city",
    slug: "gaur-city",
    name: "J.D. Dental Care – Gaur City",
    shortName: "Gaur City",
    address: "Aarza Square, L.G.F.-22, 7th Avenue, Gaur City 1, Sector 4, Greater Noida West, UP 201009",
    fullAddress: "Aarza Square, L.G.F.-22, 7th Avenue, Gaur City 1, Sector 4, Greater Noida West, Uttar Pradesh 201009",
    phone: "099588 81524",
    email: "vnsn1524@gmail.com",
    rating: 4.9,
    reviewCount: 118,
    hours: {
      weekday: "9:30 AM – 12:30 PM, 5:30 PM – 8:00 PM",
      saturday: "9:30 AM – 12:30 PM, 5:30 PM – 8:00 PM",
      sunday: "Closed",
    },
    mapUrl: "https://www.google.com/maps/place/J.D.+Dental+Care/@28.5750,77.3400,17z",
    embedMapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3505.5!2d77.3400!3d28.5750!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDM0JzI4LjAiTiA3N8KwMjQnMjQuMCJF!5e0!3m2!1sen!2sin!4v1234567890",
    landmark: "Located in Aarza Square, near Gaur City Mall",
    features: [
      "General Dentistry",
      "Cosmetic Dentistry",
      "Dental Implants",
      "Teeth Cleaning & Polishing",
      "Wisdom Tooth Removal",
      "Dental Crowns & Bridges",
    ],
  },
];

export const SERVICES: ServiceItem[] = [
  {
    id: "general-checkup",
    slug: "general-checkup",
    title: "General Checkup",
    category: "Preventive Care",
    description: "Regular checkups help detect problems early and keep your smile healthy.",
    fullDetails:
      "Comprehensive diagnostic evaluation utilizing AI-assisted high-definition intraoral 3D scanning, digital low-radiation bitewing X-rays, periodontal gum staging, and non-invasive cancer screening to protect your oral wellness before issues arise.",
    benefits: [
      "High-Definition 3D Intraoral Digital Imaging",
      "Low-Dose Digital Bitewing Radiography",
      "Periodontal Health & Tartar Depth Indexing",
      "Oral Cancer & Pre-cancerous Lesion Screen",
      "Personalized Prevention Care Roadmap",
    ],
    duration: "30 - 45 Mins",
    priceEstimate: "₹499",
    image: "/images/service-checkup.jpg",
    iconName: "Stethoscope",
    badgeText: "Preventive",
  },
  {
    id: "teeth-whitening",
    slug: "teeth-whitening",
    title: "Teeth Whitening",
    category: "Cosmetic Care",
    description: "Brighten your smile safely with our advanced whitening treatments.",
    fullDetails:
      "Achieve 6 to 8 shades lighter teeth in a single 45-minute clinical appointment. Utilizing genuine Philips Zoom! Whitespeed 3D Blue LED activation with custom enamel-strengthening ACP (Amorphous Calcium Phosphate) desensitizing technology.",
    benefits: [
      "Up to 8 Shades Whiter in 45 Minutes",
      "Clinically Proven Zero-Enamel Erosion Formula",
      "Custom Post-Treatment Desensitizing Gel Guard",
      "Safe on Restorations and Natural Enamel",
      "Includes Take-Home Touchup Whitening Pen",
    ],
    duration: "45 - 60 Mins",
    priceEstimate: "₹9,999",
    image: "/images/service-whitening.jpg",
    iconName: "Sparkles",
    badgeText: "Cosmetic",
  },
  {
    id: "dental-implants",
    slug: "dental-implants",
    title: "Dental Implants",
    category: "Restorative Care",
    description: "Replacement of missing teeth with natural-looking and durable implants.",
    fullDetails:
      "Led by our lead specialist (MDS Implantology), we specialize in computer-guided keyhole implant placement utilizing titanium/zirconia grade-5 fixtures (Nobel Biocare & Straumann) with same-day permanent ceramic teeth.",
    benefits: [
      "Computer-Guided 3D Keyhole Surgery",
      "Zero Incision, Minimal Bleeding & Fast Healing",
      "Lifetime Warranty on Titanium Fixtures",
      "Natural Look, Strength & Chewing Precision",
      "Immediate Loading (Same-Day Fixed Crown)",
    ],
    duration: "45 Mins / Single Fixture",
    priceEstimate: "₹24,999",
    image: "/images/service-implants.jpg",
    iconName: "ShieldCheck",
    badgeText: "Implantology",
  },
  {
    id: "orthodontics",
    slug: "orthodontics",
    title: "Orthodontics",
    category: "Orthodontics",
    description: "Straighten your teeth and improve your smile with modern orthodontic care.",
    fullDetails:
      "Led by our specialist (MDS Orthodontics), we offer 3D digital smile simulation with Clear Invisible Aligners (Invisalign Diamond Provider), ceramic self-ligating braces, and Lingual braces for seamless teeth realignment.",
    benefits: [
      "Custom 3D ClinCheck Video Simulation",
      "Virtually Invisible Ultra-Thin Aligners",
      "No Food Restrictions & Easy Flossing",
      "Up to 40% Faster Treatment with SmartTrack",
      "Retainers and 1-Year Followup Included",
    ],
    duration: "6 - 14 Months Plan",
    priceEstimate: "₹35,000 onwards",
    image: "/images/service-orthodontics.jpg",
    iconName: "Smile",
    badgeText: "Aligners & Braces",
  },
  {
    id: "oral-maxillofacial-surgery",
    slug: "oral-maxillofacial-surgery",
    title: "Oral and Maxillofacial Surgery",
    category: "Oral Surgery",
    description: "Advanced surgical care for complex dental and facial conditions, performed by a specialist oral surgeon.",
    fullDetails:
      "Led by Dr. V.K. Saini (Lead Oral Surgeon with 15+ years of clinical experience), we perform advanced oral and maxillofacial procedures including complicated extractions, wisdom tooth surgery, jaw fracture surgery, and cyst & tumour removal — all under strict sterilization protocols with modern anesthesia techniques for maximum comfort and safety.",
    benefits: [
      "Specialist-Led Surgery by Dr. V.K. Saini (15+ Years)",
      "Complicated Extractions & Wisdom Tooth Surgery",
      "Jaw Fracture & Facial Trauma Management",
      "Cyst and Tumour Removal with Precision Diagnostics",
      "Painless Procedures with Modern Anesthesia",
    ],
    duration: "60 - 90 Mins",
    priceEstimate: "On Consultation",
    image: "/images/surgery-headlight.jpg",
    iconName: "Activity",
    badgeText: "Surgical",
  },
];

export const DOCTORS: Doctor[] = [
  {
    id: "dr-vinay",
    name: "Dr. V.K. Saini",
    role: "Lead Oral Surgeon",
    qualifications: "MDS, King George Medical University",
    experience: "15+ Years Clinical Excellence",
    speciality: "Oral Surgery, Dental Implants, Full Mouth Rehabilitation, Cleft Lip & Palate Management",
    bio: "Dr. V.K. Saini is the lead oral surgeon at J.D. Dentals, bringing over 15 years of clinical experience in comprehensive and surgical dentistry. A graduate of King George Medical University, Dr. Saini is passionate about creating healthy, confident smiles while easing anxiety for nervous patients. He regularly completes advanced training in surgical procedures and digital dentistry. Dr. Saini has over 10 years of experience in implants and full mouth rehabilitation. He is also associated with several hospitals and institutions for educating budding dental professionals.",
    awards: [
      "Excellence Award in Pain Management",
      "Certificate Course in Forensic Odontology",
      "Fellowship in Implantology",
      "Certification in Cleft Lip and Palate Management",
    ],
    availableDays: "Mon – Sat (Sky Plaza & Gaur City)",
    clinics: ["Sky Plaza – Greater Noida", "Gaur City – Greater Noida"],
    image: "/images/dr-vinay.jpg",
    // Booking routing — call & WhatsApp for Dr. V.K. Saini.
    phone: "098000 00881",
    whatsapp: "919800000881",
    isFeatured: true,
  },
  {
    id: "dr-shivani",
    name: "Dr. Shivani Saini",
    role: "General & Cosmetic Dentist",
    qualifications: "BDS, UDMRI College (U.K.)",
    experience: "12+ Years Clinical Excellence",
    speciality: "General & Cosmetic Dentistry, Orthodontic Braces, Invisalign, Teeth Whitening, Root Canal Treatment",
    bio: "Dr. Shivani Saini earned her Bachelor of Dental Surgery (BDS) from UDMRI College (U.K.) and has spent over 12 years helping patients achieve healthy, confident smiles. She is certified in advanced restorative procedures and Invisalign, and she stays up to date on modern dental technology through continuous education. Dr. Shivani focuses on gentle, patient-centered care to ensure every visit is comfortable and stress-free. She has completed various certificate courses including root canal treatment and paediatric dentistry.",
    awards: [],
    availableDays: "Mon – Sat (Sky Plaza & Gaur City)",
    clinics: ["Sky Plaza – Greater Noida", "Gaur City – Greater Noida"],
    image: "/images/doctor-shivani.jpg",
    // Booking routing — call & WhatsApp for Dr. Shivani Saini.
    phone: "+91 99588 81524",
    whatsapp: "919958881524",
    isFeatured: false,
  },
];

export const TESTIMONIALS: Testimonial[] = [
  {
    id: "test-1",
    quote:
      "The team is amazing! I felt comfortable and cared for throughout my treatment. Dr. Vinay did my implant surgery at Sky Plaza, and I felt zero pain. Highly recommended to everyone in Greater Noida!",
    name: "Jessica P.",
    role: "Happy Patient",
    location: "Sector 50, Greater Noida",
    treatment: "Dental Implant & Ceramic Crown",
    rating: 5,
    image: "/images/unsplash-jessica-patient.jpg",
  },
  {
    id: "test-2",
    quote:
      "Dr. Shivani planned my Invisalign treatment with 3D scanning. In just 9 months, my severe crowding was completely fixed without any tooth extractions. The clinic ambience is like a 5-star lounge.",
    name: "Rahul Sharma",
    role: "Software Architect",
    location: "Sector 137, Greater Noida",
    treatment: "Clear Aligners / Invisalign",
    rating: 5,
    image: "/images/unsplash-rahul-patient.jpg",
  },
  {
    id: "test-3",
    quote:
      "I had extreme dental anxiety from past experiences. Dr. Vinay and Dr. Shivani performed a single-sitting painless root canal and Zoom whitening at Gaur City. I can finally smile with complete confidence!",
    name: "Priya Malhotra",
    role: "Senior HR Director",
    location: "Indirapuram, NCR",
    treatment: "Digital Smile Makeover & Zoom Whitening",
    rating: 5,
    image: "/images/unsplash-priya-patient.jpg",
  },
  {
    id: "test-3",
    quote:
      "I had extreme dental anxiety from past experiences. Dr. Vinay and Dr. Shivani performed a single-sitting painless root canal and Zoom whitening at Gaur City. I can finally smile with complete confidence!",
    name: "Priya Malhotra",
    role: "Senior HR Director",
    location: "Indirapuram, NCR",
    treatment: "Digital Smile Makeover & Zoom Whitening",
    rating: 5,
    image: "/images/why-us-consultation.jpg",
  },
];

export const PRICING_PLANS: PricingPlan[] = [
  {
    id: "basic-care",
    name: "Basic Care",
    priceInr: "₹1,999",
    priceUsd: "₹1,999",
    period: "per month / billed annually",
    iconName: "HeartPulse",
    recommendedFor: "Individuals seeking regular preventive wellness and routine cleanings in Greater Noida.",
    features: [
      "Regular Checkup (Twice Yearly)",
      "Ultrasonic Teeth Cleaning & Scaling",
      "Direct Consultation with Dr. Vinay / Dr. Shivani",
      "Digital X-Ray (if needed, zero extra fee)",
      "20% Discount on Basic Composite Fillings",
      "Priority Emergency Slot in Greater Noida",
    ],
  },
  {
    id: "premium-care",
    name: "Premium Care",
    priceInr: "₹4,999",
    priceUsd: "₹4,999",
    period: "per month / billed annually",
    iconName: "Crown",
    isPopular: true,
    recommendedFor: "Patients desiring complete aesthetic enhancement, whitening, and priority specialist care.",
    features: [
      "Everything in Basic Care",
      "1x Annual In-Office Philips Zoom! Teeth Whitening",
      "Advanced 3D AI Digital Smile Consultation",
      "VIP Priority Booking with Dr. Vinay & Dr. Shivani",
      "Fluoride & Enamel Remineralization Therapy",
      "35% Discount on Implants & Invisible Aligners",
      "Family Add-on Discount (25% off for Spouse)",
    ],
  },
  {
    id: "family-care",
    name: "Family Care",
    priceInr: "₹9,999",
    priceUsd: "₹9,999",
    period: "per month / billed annually",
    iconName: "Users",
    recommendedFor: "Comprehensive all-in-one dental security for up to 4 family members in Greater Noida.",
    features: [
      "Everything in Premium Care (Up to 4 Family Members)",
      "Quarterly Family Checkups & Deep Polishing",
      "Special Discounts on Pediatric & Orthodontic Care",
      "24/7 On-Call Emergency Dentist Helpline",
      "Zero Waiting Time in Both Greater Noida Clinics",
      "Free Annual Oral Health Care Kit for Kids",
      "Free Replacement for Lost Retainers / Nightguards",
    ],
  },
];

export const BLOG_POSTS: BlogPost[] = [
  {
    id: "post-1",
    title: "5 Evidence-Based Tips for Maintaining Healthy Teeth & Enamel",
    slug: "5-tips-for-maintaining-healthy-teeth",
    date: "May 05, 2025",
    readTime: "4 min read",
    author: "Dr. V.K. Saini (Lead Oral Surgeon)",
    category: "Oral Hygiene",
    image: "/images/blog-enamel.jpg",
    excerpt: "Discover essential clinical practices to fortify tooth enamel, balance oral microbiome pH, and prevent tartar calcification.",
    content: [
      "Brushing twice daily is the bedrock of dental health, but technique and timing matter just as much as consistency. Using a soft-bristled oscillating electric toothbrush with low-abrasive hydroxyapatite or fluoride toothpaste prevents microscopic micro-scratches on your enamel.",
      "Wait at least 30 minutes after consuming acidic foods or citrus beverages before brushing. Acid softens the outer calcium matrix temporarily; brushing immediately can scrub away delicate enamel prisms.",
      "Incorporate interdental cleaning daily. Traditional floss or a high-frequency water flosser removes biofilm from the 35% of tooth surface area that toothbrushes cannot reach.",
      "Stay hydrated to maintain natural saliva buffering capacity. Saliva contains essential calcium and phosphate ions that actively remineralize microscopic enamel demineralizations throughout the day.",
      "Schedule professional dental prophylaxis every 6 months to remove subgingival calculus that cannot be removed by home brushing.",
    ],
  },
  {
    id: "post-2",
    title: "How Often Should You Visit the Dentist? A Specialist's Guide",
    slug: "how-often-should-you-visit-the-dentist",
    date: "May 08, 2025",
    readTime: "5 min read",
    author: "Dr. Shivani Saini (General & Cosmetic Dentist)",
    category: "Preventive Dentistry",
    image: "/images/blog-checkup.jpg",
    excerpt: "Why the standard 6-month rule might need personal customization based on your individual gum health, genetics, and restorations.",
    content: [
      "The traditional rule of visiting a dentist twice a year originated as a general guideline, but modern personalized dentistry assesses individual periodontal risk factors to formulate custom recall intervals.",
      "High-risk patients—such as individuals with diabetes, orthodontic appliances, active gum inflammation, or smokers—often benefit from 3-to-4-month recall appointments to prevent periodontal pocket deepening.",
      "Low-risk patients with robust bone density and impeccable oral hygiene may safely maintain a 6-month checkup cycle for 3D digital imaging and preventive plaque removal.",
      "At J.D. Dentals in Greater Noida, our specialists use digital AI scanners to track micro-recession, wear facets, and bite balance dynamically across every checkup.",
    ],
  },
  {
    id: "post-3",
    title: "The Benefits of Professional Teeth Whitening vs. At-Home Kits",
    slug: "the-benefits-of-teeth-whitening",
    date: "May 08, 2025",
    readTime: "4 min read",
    author: "Dr. V.K. Saini & Dr. Shivani Saini",
    category: "Cosmetic Dentistry",
    image: "/images/blog-whitening.jpg",
    excerpt: "Understand how clinical Zoom 3D Blue Light technology achieves brighter, safer results without damaging sensitive pulp tissue.",
    content: [
      "Over-the-counter whitening strips and abrasive charcoal pastes often cause severe tooth sensitivity or micro-abrasions on enamel because they lack custom gingival barriers and regulated pH buffers.",
      "Professional in-office whitening uses hydrogen peroxide formulations activated by cold blue LED wavelengths. This breaks down chromogenic stain molecules deep inside the dentin layer without dehydrating the pulp.",
      "Clinical treatments incorporate desensitizing amorphous calcium phosphate (ACP), which seals open dentinal tubules immediately during the whitening session.",
      "Results from professional clinical whitening can last 18 to 24 months with simple maintenance and good oral hygiene.",
    ],
  },
];

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/services" },
  { label: "About", href: "/about" },
  { label: "Doctors", href: "/doctors" },
  { label: "Locations", href: "/locations" },
  { label: "Blog", href: "/blog" },
  { label: "Pricing", href: "/pricing" },
  { label: "Contact", href: "/contact" },
];
